export default __webpack_public_path__ + "static/media/crt4.d1d73b48.jpg";